export const goToCreateCompanyForms = (company, history, user) => {
  history.push("/".concat(user.account_type, "/companies/new/").concat(company.id_in_provider_system, "--").concat(company.number));
};